<template>
    <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">
        <vs-tab icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? 'Datos Generales' : ''">
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
                <user-general />
            </div>
        </vs-tab>
        <vs-tab icon-pack="feather" icon="icon-layers" :label="!isSmallerScreen ? 'Proyectos Asignados' : ''">
            <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
                <user-proyecto />
            </div>
        </vs-tab>
        <vs-tab icon-pack="feather" icon="icon-bell" :label="!isSmallerScreen ? 'Notificaciones' : ''">
            <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
                <user-notificacion/>
            </div>
        </vs-tab>
    </vs-tabs>
</template>
<script>
import UserGeneral from './components/UserGeneral.vue';
import UserNotificacion from './components/UserNotificacion.vue';
import UserProyecto from './components/UserProyecto.vue';

export default {
    components: {
        UserGeneral,
        UserNotificacion,
        UserProyecto
    },

    data(){
        return {

        }
    },

    computed: {
        isSmallerScreen () {
            return this.$store.state.windowWidth < 768
        }
    }

}
</script>